import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantResidenceDetailsPage = {
  alert: {
    error: 'applicant-residence-details-page.form.alert.error',
  },
  footer: {
    root: 'applicant-residence-details-page.footer.root',
  },
  form: {
    addressLine1Input:
      'applicant-residence-details-page.form.address-line-1-input',
    addressLine1InputError:
      'applicant-residence-details-page.form.address-line-1-input-error',
    addressLine2Input:
      'applicant-residence-details-page.form.address-line-2-input',
    amountInput: 'applicant-residence-details-page.form.amount-input',
    amountInputError:
      'applicant-residence-details-page.form.amount-input-error',
    cityInput: 'applicant-residence-details-page.form.city-input',
    cityInputError: 'applicant-residence-details-page.form.city-input-error',
    h1: 'applicant-residence-details-page.form.h1',
    h2: 'applicant-residence-details-page.form.h2',
    root: 'applicant-residence-details-page.form.root',
    stateSelect: 'applicant-residence-details-page.form.state-select',
    stateSelectError:
      'applicant-residence-details-page.form.state-select-error',
    submitButton: 'applicant-residence-details-page.form.submit-button',
    zipCodeInput: 'applicant-residence-details-page.form.zip-code-input',
    zipCodeInputError:
      'applicant-residence-details-page.form.zip-code-input-error',
  },
} as const satisfies PageLocatorMap;
